import { isFeatureEnabled } from "config/features"
import i18n from "i18n"
import { routes } from "router/routes"

const proNewListingMenuKeys = {
  details: "details",
  scheduling: "scheduling",
  media: "media",
  resources: "resources",
  location: "location",
  digital_waiver: "digital_waiver",
  tax_fees: "tax_fees",
  preview: "preview"
}

export const proNewListingMenuList = [
  {
    label: i18n.t("listings.tabs.details.label"),
    title: i18n.t("listings.tabs.details.title"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceDetailsPath({ id }) : routes.proNewListingDetailsPath({ id })),
    id: proNewListingMenuKeys.details,
    percent: 0
    // status: false
  },
  {
    label: i18n.t("listings.tabs.scheduling.label"),
    title: i18n.t("listings.tabs.scheduling.title"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceSchedulingPath({ id }) : routes.proNewListingSchedulingPath({ id })),
    id: proNewListingMenuKeys.scheduling,
    percent: 30
    // status: false
  },
  {
    label: i18n.t("listings.tabs.media.label"),
    title: i18n.t("listings.tabs.media.title"),
    subTitle: i18n.t("listings.tabs.media.subtitle"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceMediaPath({ id }) : routes.proNewListingMediaPath({ id })),
    id: proNewListingMenuKeys.media,
    percent: 45
    // status: false
  },
  {
    label: i18n.t("listings.tabs.resources.label"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceResourcesPath({ id }) : routes.proNewListingResourcesPath({ id })),
    id: proNewListingMenuKeys.resources,
    percent: 65
    // status: false
  },
  {
    label: i18n.t("listings.tabs.location.label"),
    title: i18n.t("listings.tabs.location.title"),
    subTitle: i18n.t("listings.tabs.location.subtitle"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceLocationPath({ id }) : routes.proNewListingLocationPath({ id })),
    id: proNewListingMenuKeys.location,
    percent: 85
    // status: false
  },
  ...(isFeatureEnabled("CUSTOM_TEMPLATE") ? [{
    label: i18n.t("listings.tabs.digital_waiver.label"),
    title: i18n.t("listings.tabs.digital_waiver.title"),
    // subTitle: i18n.t("listings.tabs.digital_waiver.subtitle"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceDigitalWaiverPath({ id }) : routes.proNewListingDigitalWaiverPath({ id })),
    id: proNewListingMenuKeys.digital_waiver,
    percent: 90
  }] : []),
  {
    label: i18n.t("listings.tabs.tax_fees.label"),
    title: i18n.t("listings.tabs.tax_fees.title"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperienceTaxFeesPath({ id }) : routes.proNewListingTaxFeesPath({ id })),
    id: proNewListingMenuKeys.tax_fees,
    percent: 92
  },
  {
    label: i18n.t("listings.tabs.preview.label"),
    title: i18n.t("listings.tabs.preview.title"),
    subTitle: i18n.t("listings.tabs.preview.subtitle"),
    path: (id, isEdit) => (isEdit ? routes.proEditExperiencePreviewPath({ id }) : routes.proNewListingPreviewPath({ id })),
    id: proNewListingMenuKeys.preview,
    percent: 95
  }
]
